"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeProjectStatus = changeProjectStatus;
exports.deleteProject = deleteProject;
exports.editFudouCard = editFudouCard;
exports.exportFudouProjectList = exportFudouProjectList;
exports.getActiveCustomers = getActiveCustomers;
exports.getCardDetail = getCardDetail;
exports.getCardList = getCardList;
exports.getCardListApi = getCardListApi;
exports.getCustomerList = getCustomerList;
exports.getFudouProjectDetail = getFudouProjectDetail;
exports.getFudouProjectList = getFudouProjectList;
exports.getMiniappList = getMiniappList;
exports.getProjectCardDetailApi = getProjectCardDetailApi;
exports.getProjectDetail = getProjectDetail;
exports.getProjectList = getProjectList;
exports.getProjectStatuses = getProjectStatuses;
exports.getProjectTypes = getProjectTypes;
exports.saveProject = saveProject;
var _request = _interopRequireDefault(require("@/utils/request"));
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 获取福豆项目列表
 */
function getFudouProjectList() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _requestMapi.default)({
    //url: '/admin/fudou/project/index',
    url: '/mapi/asset/web/fudou/project/index',
    method: 'GET',
    params: params
  });
}

/**
 * 获取项目列表
 */
function getProjectList(params) {
  return (0, _request.default)({
    url: '/admin/welfare/project/list',
    method: 'get',
    params: params
  });
}

/**
 * 添加或更新项目
 */
function saveProject() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: '/admin/welfare/project/save',
    method: 'POST',
    data: data
  });
}

/**
 * 删除项目
 */
function deleteProject(id) {
  return (0, _request.default)({
    url: "/admin/welfare/project/delete",
    method: 'DELETE',
    params: {
      id: id
    }
  });
}

/**
 * 获取项目详情
 */
function getProjectDetail(id) {
  return (0, _request.default)({
    url: '/admin/fudou/project/detail',
    method: 'get',
    params: {
      id: id
    }
  });
}

/**
 * 修改项目状态
 */
function changeProjectStatus(data) {
  return (0, _request.default)({
    url: '/admin/welfare/project/status',
    method: 'POST',
    params: data
  });
}

/**
 * 获取项目类型选项
 */
function getProjectTypes() {
  return (0, _request.default)({
    url: '/admin/welfare/project/types',
    method: 'GET'
  });
}

/**
 * 获取项目状态选项
 */
function getProjectStatuses() {
  return (0, _request.default)({
    url: '/admin/welfare/project/statuses',
    method: 'GET'
  });
}

/**
 * 获取活跃的客户列表
 */
function getActiveCustomers() {
  // return request({
  //   url: '/admin/customers/active-customers',
  //   method: 'get'
  // });
  return (0, _requestMapi.default)({
    url: "/mapi/user/customer/active-customers",
    method: 'GET'
  });
}

/**
 * 获取卡片列表
 */
function getCardList() {
  return (0, _request.default)({
    url: '/admin/welfare/card/list',
    method: 'get',
    params: {
      page: 1,
      limit: 100
    }
  });
}

/**
 * 查看卡片详情
 */
function getCardDetail(id) {
  return (0, _request.default)({
    url: '/admin/welfare/project/card/detail',
    method: 'GET',
    params: {
      id: id
    }
  });
}

/**
 * 获取归属客户列表
 */
function getCustomerList(params) {
  // return request({
  //   url: '/admin/customers/active-customers',
  //   method: 'GET',
  //   params: params || { page: 1, limit: 100 }
  // });
  return (0, _requestMapi.default)({
    url: "/mapi/user/customer/active-customers",
    method: 'GET',
    params: params || {
      page: 1,
      limit: 100
    }
  });
}

/**
 * 获取小程序列表
 */
function getMiniappList() {
  // return request({
  //   url: '/admin/companyapp/autoList',
  //   method: 'get',
  //   params: { keyword: '' }
  // });
  return (0, _requestMapi.default)({
    url: '/mapi/user/admin/company-app/autoList',
    method: 'get',
    params: {
      keyword: ''
    }
  });
}

/**
 * 导出项目列表
 */
function exportFudouProjectList() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: '/admin/fudou/project/export',
    method: 'GET',
    params: params
  });
}

/**
 * 获取福豆项目详情
 */
function getFudouProjectDetail(id) {
  return (0, _request.default)({
    url: '/admin/fudou/project/detail',
    method: 'GET',
    params: {
      id: id
    }
  });
}

/**
 * 获取项目福卡详情
 */
function getProjectCardDetailApi(id) {
  return (0, _requestMapi.default)({
    url: "/mapi/asset/customer/integral-log/fudou-card/info/".concat(id),
    method: 'GET'
  });
}

/**
 * 获取福卡列表
 */
function getCardListApi() {
  return (0, _request.default)({
    url: 'admin/fudou/fucard/select',
    method: 'GET'
  });
}

/**
 * 变更福卡
 */
function editFudouCard(data) {
  return (0, _requestMapi.default)({
    url: '/mapi/asset/customer/integral-log/fudou-card/edit',
    method: 'POST',
    data: data
  });
}